var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-alert",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          attrs: { color: "primary", value: "true", outline: "" }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("visioTitle1")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ]),
          _vm._v(". " + _vm._s(_vm.$t("visioTitle2")) + ".\n    ")
        ]
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert,
              expression: "alert"
            }
          ],
          attrs: {
            color: "secondary",
            icon: "warning",
            value: "true",
            outline: ""
          }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("warningVisioDisabled")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.loadingGet
            ? _c(
                "div",
                { staticClass: "text-xs-center" },
                [
                  _c("v-progress-circular", {
                    staticClass: "primary--text",
                    attrs: { indeterminate: "", size: 100, width: 1 }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "mb-3" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-switch", {
                            attrs: {
                              label: _vm.visioOnOff
                                ? "VISIO ASSISTANCE ON"
                                : "DEMANDES DE VISIO ASSISTANCE OFF",
                              light: "",
                              color: "primary"
                            },
                            model: {
                              value: _vm.visioOnOff,
                              callback: function($$v) {
                                _vm.visioOnOff = $$v
                              },
                              expression: "visioOnOff"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    block: _vm.$vuetify.breakpoint.xsOnly,
                    loading: _vm.loadingPost,
                    disabled: _vm.alert
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.postOptions()
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm._f("cap")(_vm.$t("save")))),
                  _c("v-icon", { attrs: { dark: "", right: "" } }, [
                    _vm._v("save")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb9f16e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb9f16e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Visioconf.vue
// module id = null
// module chunks = 